import {trackMixpanelService} from "../../services/mixpanel"
import { useGlobalStore } from "../../zustand-store/useGlobalStore"
import {
    ADD_AUDIO_COMPOSER_BLOCK, 
    REMOVE_AUDIO_COMPOSER_BLOCK, 
    EXIT_EDITOR,
    UPDATE_AUDIO_COMPOSER_BLOCK_MOVE_LEFT,
    UPDATE_AUDIO_COMPOSER_BLOCK_MOVE_RIGHT,
    ADD_AUDIO_COMPOSER_AUDIO_BLOCK
} from "../actionTypes"

// Mixpanel middleware for editor
const mixpanelMiddleware = store => next => action => {
    if([
        ADD_AUDIO_COMPOSER_BLOCK, 
        REMOVE_AUDIO_COMPOSER_BLOCK, 
        EXIT_EDITOR,
        UPDATE_AUDIO_COMPOSER_BLOCK_MOVE_LEFT,
        UPDATE_AUDIO_COMPOSER_BLOCK_MOVE_RIGHT,
        ADD_AUDIO_COMPOSER_AUDIO_BLOCK
    ].includes(action.type)){
        const eventName = action.type
        const eventData = { val : action.type === EXIT_EDITOR ? action.payload.reason : action.payload }
        
        // ✨ Get context from Zustand store instead of Redux
        const { orgId, integrationId, contentId } = useGlobalStore.getState()
        
        // Track only if all required IDs are available
        if(orgId && integrationId && contentId){
            trackMixpanelService({orgId, integrationId, contentId, body : {eventName, eventData}})
        }
    }

    next(action);
}

export default mixpanelMiddleware